export default "__VITE_ASSET__BJnqm$Yf__"